import React, { useEffect, useState } from 'react';
import { Button, Spinner } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { obtenerDetallesPuntajeAdicional } from '../../../actions/cursosActions';

const DetallePuntosModal = ({ id_estudiante, id_proyecto, puntosAsistencia = 0, onClose }) => {


    const [puntajesAdicionales, setPuntajesAdicionales] = useState([]);
    const [loading, setLoading] = useState(true);
    const dispatch = useDispatch();

    useEffect(() => {
  dispatch(obtenerDetallesPuntajeAdicional(id_estudiante, id_proyecto)).then((res) => {
    setPuntajesAdicionales(Array.isArray(res) ? res : []);
    setLoading(false);
  });
}, [dispatch, id_estudiante, id_proyecto]);



const listaPuntajes = [
    ...puntajesAdicionales,
    ...(Number(puntosAsistencia) > 0
        ? [{
            tipo_puntaje_descripcion: "Asistencia a clases",
            puntaje_total: puntosAsistencia
        }]
        : [])
];

const totalAdicionales = listaPuntajes.reduce((total, puntaje) => {
    return total + (puntaje.puntaje_total ? parseInt(puntaje.puntaje_total, 10) : 0);
}, 0);


    if (loading) {
        return (
            <div className="detalle-puntos-loading">
                <Spinner animation="border" />
            </div>
        );
    }

    return (
        <div className="detalle-puntos-modal-content">
            {listaPuntajes.length > 0 ? (

                <div className="detalle-puntos-list">
                    {listaPuntajes.map((puntaje, index) => (

                        <div className="detalle-puntos-row" key={index}>
                            <div className="detalle-puntos-name">
                                <span className="detalle-puntos-dot"></span>
                                <span>{puntaje.tipo_puntaje_descripcion}</span>
                                <span className="detalle-puntos-status">completado</span>
                            </div>
                            <strong>+{parseInt(puntaje.puntaje_total, 10)} pts</strong>
                        </div>
                    ))}
                </div>
            ) : (
                <div className="detalle-puntos-empty">No hay puntajes adicionales.</div>
            )}

            <div className="detalle-puntos-footer">
                <div>
                    <span>Total adicionales</span>
                    <strong>{totalAdicionales} pts</strong>
                </div>
                <Button variant="light" onClick={onClose}>
                    Cerrar
                </Button>
            </div>
        </div>
    );
};

export default DetallePuntosModal;
